const hasValue = (value: unknown) => value !== null && value !== undefined && String(value).trim() !== "";

export const formatBp = (systolic?: unknown, diastolic?: unknown) => {
  if (!hasValue(systolic) && !hasValue(diastolic)) return "-";
  return `${hasValue(systolic) ? systolic : "-"}/${hasValue(diastolic) ? diastolic : "-"} mm Hg`;
};

export const formatPulse = (value?: unknown) => (hasValue(value) ? `${value}/min` : "-");

export const formatSpo2 = (value?: unknown) => (hasValue(value) ? `${value}%` : "-");

export const formatTempF = (value?: unknown) => (hasValue(value) ? `${value}⁰F` : "-");

export const formatHeight = (value?: unknown) => {
  if (!hasValue(value)) return "-";
  const raw = String(value).trim();
  return `${raw} cm`;
};

export const formatHeightParts = (feet?: unknown, inches?: unknown, fallbackHeight?: unknown) => {
  if (hasValue(fallbackHeight)) return formatHeight(fallbackHeight);

  if (hasValue(feet) || hasValue(inches)) {
    return `${hasValue(feet) ? feet : "0"}'${hasValue(inches) ? inches : "0"}"`;
  }

  return "-";
};

export const formatWeight = (value?: unknown) => (hasValue(value) ? `${value} kg` : "-");
